import {
    ActivatedRouteSnapshot,
    Resolve,
    RouterStateSnapshot
} from '@angular/router';
import { StoreConfigurationsService } from '../services/store-configurations.service';
import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { CommonHttpService } from '../services/http.service';

@Injectable()
export class ConfigurationsResolver implements Resolve<any> {
    constructor(
        protected storeConfigurations: StoreConfigurationsService,
        protected http: CommonHttpService
    ) { }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> {
        this.storeConfigurations.dataLoad();
        return this.storeConfigurations.dataLoaded$;
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src3894461559/src/src/app/shared/resolvers/configurations.resolver.ts